// Copyright (c) 2016 Deere & Company

import TimestampUser, {getDefaultState as getTimestampUserDefaultState} from './timestamp-user';
import t from 'tcomb';

const Option = t.struct({
    canBeDeleted: t.Bool,
    changedBy: t.maybe(TimestampUser),
    changedDate: t.maybe(t.Number),
    createdBy: t.maybe(TimestampUser),
    createdDate: t.maybe(t.Number),
    description: t.String,
    id: t.String,
    optionCode: t.String,
    pin: t.String
}, {
    name: 'Option',
    strict: true
});

export const getDefaultState = () => new Option({
    canBeDeleted: false,
    changedBy: getTimestampUserDefaultState(),
    changedDate: null,
    createdBy: getTimestampUserDefaultState(),
    createdDate: null,
    description: '',
    id: '',
    optionCode: '',
    pin: ''
});

export default Option;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/option.js